// @mention token format stored inline in comment/markdown bodies:
//   @[Display Name](/team/<userId>)
// The leading "@" renders as literal text; the bracketed part is a normal
// Markdown link to the member's profile, so existing renderers/sanitizers
// handle it. The server parses these to know who to notify.

const MENTION_RE = /@\[[^\]]+\]\(\/team\/([A-Za-z0-9_-]+)\)/g;

/** Extract the unique mentioned user ids from a body. */
export function parseMentions(body: string): string[] {
  const ids = new Set<string>();
  for (const m of body.matchAll(MENTION_RE)) {
    if (m[1]) ids.add(m[1]);
  }
  return [...ids];
}

/** Build the inline mention token for a member. */
export function mentionToken(userId: string, name: string): string {
  return `@[${name}](/team/${userId})`;
}
